// extracted by mini-css-extract-plugin
export default {"background":"ProgressBar_background__9Qv2C","progress":"ProgressBar_progress__y1h-9"};